import React, { useEffect, useState } from 'react'
import { formatMoney } from 'helpers/Currency';
import { Card, Col, Row, Spinner } from "react-bootstrap";

import * as processingPaymentColor from '../../images/processing-payment-color.png';
import * as valueAvailableColor from '../../images/value-available-color.png';
import * as paidColor from '../../images/paid-color.png';
import DashboardRequestService from 'services/dashboard-request';

export default function ({ fiscalYear }) {
  const [data, setData] = useState({ names: [], data: {} })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    DashboardRequestService
    .getFundValuesElitePass({ params: { __fiscal_year_id: fiscalYear.id, __fund_type_id: fiscalYear.types.map(a=>a.id) } })
    .then(({ data }) => {
      setData(data)
      setLoading(false)
    })
  }, [fiscalYear])

  return (
    <Row>
      <Col className="p-1 pb-2" xl="12" lg="12" md="12">
        <Card.Body className="card-dashboard shadow bg-white rounded h-100 w-100">
          <Row className="justify-content-around mb-2">
            <Col md="12" className="text-left">
              <span className="dashboard-card-h5">Fundo</span>
            </Col>
            <Col md="12">
              <hr></hr>
            </Col>
            <Col md="4" className="text-center card-total-funds">
              <p className="dashboard-card-p-13 mb-0">Disponível para resgate</p>
              <h5 className="text-h5 font-weight-bold d-block pt-2 mt-0 mb-0">
                {loading ? (
                  <Spinner animation="border" size="sm" />
                ) : (<>
                  {formatMoney(data.data.saldo)}
                </>)}
              </h5>
            </Col>
          </Row>
          <Row className="area-funds-to-dashboard">
            <Col md="4" className="h-100 d-inline-block">
              <div className="area-funds">
                <Row>
                  <Col><h6>Fundo Total Liberado</h6></Col>
                  <Col xs="auto">
                    <img
                      className="icon-funds"
                      src={paidColor}
                      width="40"
                    />
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  {data.names.filter(a => a.id != 2).map((name) => {
                    return (
                      <Col xs="12" key={name.id}>
                        <p className="dashboard-card-p-13 mt-3 mb-0">Fundo {name.name}</p>
                        <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                          {loading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (<>
                            {formatMoney(data.data.tot_value)}
                          </>)}
                        </h5>
                      </Col>
                    );
                  })}
                  {/* 
                  <Col xs="12">
                    {data.data}
                    <p className="dashboard-card-p-13 mt-3 mb-0">Fundo ScanSource Select</p>
                    <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {formatMoney(data.epass_tot_value)}
                      </>)}
                    </h5>
                  </Col> 
                  */}
                </Row>
              </div>
            </Col>
            <Col md="4" className="h-100 d-inline-block">
              <div className="area-funds">
                <Row>
                  <Col><h6>Fundo em Processo</h6></Col>
                  <Col xs="auto">
                    <img
                      className="icon-funds"
                      src={valueAvailableColor}
                      width="40"
                    />
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  {data.names.map((name) => {
                    let text = "";

                    if (name.id == 2) {
                      text = `${name.name} em processo de pagamento`;
                    } else {
                      text = `${name.name} processo de compensação`
                    }

                    return (
                      <Col xs="12" key={name.id}>
                        <p className="dashboard-card-p-13 mt-3 mb-0">{text}</p>
                        <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                          {loading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (<>
                            {formatMoney(data.data[name.em_processo])}
                          </>)}
                        </h5>
                      </Col>
                    );
                  })}
                  {/* <Col xs="12">
                    <p className="dashboard-card-p-13 mt-3 mb-0">Encontro de Contas em processo de compensação</p>
                    <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {formatMoney(data.enccontas_em_processo)}
                      </>)}
                    </h5>
                  </Col>
                  <Col xs="12">
                    <p className="dashboard-card-p-13 mt-3 mb-0">Reembolso em processo de pagamento</p>
                    <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {formatMoney(data.reembolso_em_processo)}
                      </>)}
                    </h5>
                  </Col> */}
                  <Col xs="auto">
                    <div className="total-area-funds mt-3">
                      <p className="dashboard-card-p-13 mb-0">Total em processo</p>
                      <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (<>
                          {formatMoney(data.data.tot_em_processo)}
                        </>)}
                      </h5>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col md="4" className="h-100 d-inline-block">
              <div className="area-funds">
                <Row>
                  <Col><h6>Fundos Pagos</h6></Col>
                  <Col xs="auto">
                    <img
                      className="icon-funds"
                      src={processingPaymentColor}
                      width="40"
                    />
                  </Col>
                </Row>
                <Row className="justify-content-center">
                  {data.names.map((name) => {
                    let text = "";

                    if (name.id == 2) {
                      text = `${name.name}s Efetuados`;
                    } else {
                      text = `${name.name} Pago`
                    }

                    return (
                      <Col xs="12" key={name.id}>
                    <p className="dashboard-card-p-13 mt-3 mb-0">{text}</p>
                    <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {formatMoney(data.data[name.pago])}
                      </>)}
                    </h5>
                  </Col>
                    );
                  })}
                  {/* <Col xs="12">
                    <p className="dashboard-card-p-13 mt-3 mb-0">ScanSource Select Pago</p>
                    <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {formatMoney(data.enccontas_pago)}
                      </>)}
                    </h5>
                  </Col>
                  <Col xs="12">
                    <p className="dashboard-card-p-13 mt-3 mb-0">Reembolsos Efetuados</p>
                    <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                      {loading ? (
                        <Spinner animation="border" size="sm" />
                      ) : (<>
                        {formatMoney(data.reembolso_pago)}
                      </>)}
                    </h5>
                  </Col> */}
                  <Col xs="auto">
                    <div className="total-area-funds mt-3">
                      <p className="dashboard-card-p-13 mb-0">Total pago</p>
                      <h5 className="text-h5 font-weight-bold d-block p-0 mt-0 mb-0">
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (<>
                          {formatMoney(data.data.tot_pago)}
                        </>)}
                      </h5>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Col>
    </Row>
  )
}